import React, { useEffect, useState } from "react";
import UserDetailsTabs from "./UserDetailsTabs";
import { GymBackground } from "../../../exports/Images";
import "../../../styles/incentive-system/user-details.css";
import { useGetFetch } from "../../../data/Queries";
import {
  memberFitnessProfileGet,
  memberFitnessProfileGetKey,
} from "../../../data/ApiEndpoints";
import { useSelector } from "react-redux";
import { selectToken } from "../../auth/auth.selector";
import { createNameInitial } from "../../../utils/utilityfunc";
import { formatDateTimezon } from "../../common-data/Converts";
import Loader from "../../ui/Loader";

const UserDetails = ({ row, userInfoData }) => {
  const { start_date, expire_date, pt_start_date, pt_end_date } = row || {};

  const [currentMembership, setCurrentMemberShip] = useState();
  const [profileFilters, setProfileFilters] = useState({
    user_id: row?.user_id,
  });
  const token = useSelector(selectToken);
  const {
    data: ftProfileData,
    isLoading: isLoadingFtp,
    isFetching: isFetchingftp,
    refetch: refetchftp,
  } = useGetFetch({
    url: memberFitnessProfileGet,
    key: memberFitnessProfileGetKey,
    filters: profileFilters,
    token,
  });

  useEffect(() => {
    try {
      refetchftp();
    } catch (error) {
      console.log(error);
    }
  }, [row]);

  return (
    <div className="userDetailsContainer">
      <div className="userDetailsProfileContainer my-2">
        <div className="fullWidthImage rounded-3 overflow-hidden">
          <img src={GymBackground} alt="gym" />
        </div>
        <div className="profileDescriptions">
          <div className="profileInfo">
            {row?.member_profile ? (
              <div className="profile-container">
                <img
                  className="profile-image"
                  src={row?.member_profile || row?.user_profile}
                  alt="profile"
                />
              </div>
            ) : (
              <div className="red-bg-k h-full-k rounded-2 p-4 flex-k items-center-k js-center-k">
                <h2 className="fs-x-large-k m-0 text-white bold-text">
                  {createNameInitial(row?.member_name)}
                </h2>
              </div>
            )}
            <div className="nameInfoInDetails">
              <h3 className="name m-0">
                {row?.member_name || row?.user_name || "N/A"}
              </h3>
              <p className="gymName m-0">{row?.gym_name || "N/A"}</p>
              <span
                className="flexStart expiringDate"
                style={{
                  columnGap: "10px",
                  background: "#FAECE7",
                }}
              >
                <span className="expiringDateData">PT Plan Duration: </span>

                <span className="expiringDateData">
                  {start_date || pt_start_date
                    ? formatDateTimezon(start_date || pt_start_date)
                    : "-"}{" "}
                </span>

                <span className="expiringDateData">TO </span>

                <span className="expiringDateData">
                  {expire_date || pt_end_date
                    ? formatDateTimezon(expire_date || pt_end_date)
                    : "-"}{" "}
                </span>
                {/* Expiry Date - {formatDate(currentMembership?.expire_date)} */}
              </span>
            </div>
          </div>

          {/* <div className="profileInfo"> */}
          {/* <div className="grayLine"></div> */}
          {/* <div className="nameInfoInDetails"> */}
          {/* <h3 className="subscription">{row?.member_name}</h3> */}
          {/* <p className="subscriptionDetail">
                Your workspace was Created on May 10.2023.
              </p> */}
          {/* <Button variant="danger">Send Payment link</Button> */}
          {/* </div> */}
          {/* </div> */}
        </div>
      </div>

      <div className="userDetailsTabsContainerOuter">
        {isLoadingFtp || isFetchingftp ? (
          <Loader />
        ) : (
          <UserDetailsTabs
            row={row}
            ftProfileData={ftProfileData}
            currentMembership={currentMembership}
            setCurrentMemberShip={setCurrentMemberShip}
            userInfoData={userInfoData}
          />
        )}
      </div>
    </div>
  );
};

export default UserDetails;
